module.exports = __webpack_public_path__ + "static/media/logo.fe2921d9.svg";